import { SelfServiceInstruction } from '../../api/mutations/selfService/types';
import { EWC_CLASSES } from '../../Constants';

export interface SelfServiceRoutes {
  sessionRequest: (jobsiteId: string) => string;
  sessionMain: (jobsiteId: string, sessionId: string) => string;
  sessionInfopoint: (jobsiteId: string, sessionId: string) => string;
  sessionError: (jobsiteId: string) => string;
}

export const selfServiceRoutes: SelfServiceRoutes = {
  sessionRequest: (jobsiteId: string) => `/self-service/${jobsiteId}/session-request`,
  sessionMain: (jobsiteId: string, sessionId: string) => `/self-service/${jobsiteId}/${sessionId}`,
  sessionInfopoint: (jobsiteId: string, sessionId: string) => `/self-service/${jobsiteId}/${sessionId}/infopoint`,
  sessionError: (jobsiteId: string) => `/self-service/${jobsiteId}/external-api-error`,
};

export function findEwcByLabel(label: string): { ewcNumber: string; ewcLabel: string } | undefined {
  const ewc = EWC_CLASSES.find((ewc) => ewc.label === label);
  if (ewc) {
    return {
      ewcNumber: ewc.class,
      ewcLabel: ewc.label,
    };
  }
}

export function findEwcByCodeAndLabel(avvCode: string, label: string): { class: string; label: string } | undefined {
  return EWC_CLASSES.find((ewc) => ewc.class === avvCode && ewc.label === label);
}

export function extractLabelFromTranslationKey(translationKey: string): string | null {
  const match = translationKey.match(/material\.class\.(.+)/);
  return match ? match[1] : null;
}

export function getPredictedEwcLabel(
  mainChip: { primaryText: string; secondaryText: string } | null
): string | undefined {
  if (!mainChip?.primaryText || !mainChip?.secondaryText) {
    return undefined;
  }

  const ewcCode = mainChip.primaryText;
  const extractedLabel = extractLabelFromTranslationKey(mainChip.secondaryText);

  if (!extractedLabel) {
    return undefined;
  }

  const predictedEwc = findEwcByCodeAndLabel(ewcCode, extractedLabel);
  return predictedEwc?.label;
}

export const LOCAL_STORAGE_INSTRUCTION = 'selfServiceInstruction';

export function clearLocalStorageInstruction(jobsiteId: string) {
  localStorage.removeItem(`${LOCAL_STORAGE_INSTRUCTION}${jobsiteId}`);
}

export function setLocalStorageInstruction(instruction: SelfServiceInstruction, jobsiteId: string, sessionId: string) {
  const data = {
    sessionId: sessionId,
    instruction: instruction,
  };
  localStorage.setItem(`${LOCAL_STORAGE_INSTRUCTION}${jobsiteId}`, JSON.stringify(data));
}

export function readLocalStorageInstruction(jobsiteId: string, sessionId: string) {
  const serializedInstruction = localStorage.getItem(`${LOCAL_STORAGE_INSTRUCTION}${jobsiteId}`);

  if (!serializedInstruction) return null;

  const data = JSON.parse(serializedInstruction);

  if (data.sessionId !== sessionId) {
    clearLocalStorageInstruction(jobsiteId);
    return null;
  }

  return data.instruction;
}
